import React, { Fragment, useEffect, useState } from 'react';
import Breadcrumb from '../../../layout/breadcrumb'
import { Container, Row, Col, Card, CardBody, Table, Input, CardHeader, TabContent, TabPane, Label, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { createClient } from "@supabase/supabase-js";
import jsPDF from 'jspdf'
import * as html2canvas from 'html2canvas';
import { Icon } from '@iconify/react';
import { useTranslation } from "react-i18next";
import { toast } from 'react-toastify';
import { Accordion } from 'react-bootstrap';
import { ReactBingmaps } from "react-bingmaps";
import { Geolocation } from '@capacitor/geolocation';
import 'react-toastify/dist/ReactToastify.css';
import "./styles.css"

toast.configure();

const Trip = (props) => {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  const supabase = createClient(supabaseUrl, supabaseKey);


  const { t } = useTranslation();
  const [trip_detail, settrip_detail] = useState([])
  const [completed_trip_detail, setcompleted_trip_detail] = useState([])
  const [trip_type, settrip_type] = useState([{
    trip_name: "Upcoming Trip",
  }, {
    trip_name: "Completed Trip",
  }])
  const [trip_status, settrip_status] = useState(0)
  const [trip_id, settrip_id] = useState("")

  const [tabtripdate, settabtripdate] = useState("")
  const [Large, setLarge] = useState(false);


  const [activeTab1, setActiveTab1] = useState('1');
  const [clientHeight, setclientHeight] = useState("")

  const [tabdelivery, setabdelivery] = useState("")

  const [rightSidebar, setRightSidebar] = useState(true);
  const [Buyer_coordinates, setBuyer_coordinates] = useState("")
  const [pushpinarr, setPushpinarr] = useState([{
    "latitude": 28.750591076255212,
    "longitude": 77.20027622752754,
    "title": "Buyer",
    "description": "Buyer",
  }]);
  function AddPushPinOnClick(e) {



    var arr = [];



    arr.push({
      "latitude": e.latitude,
      "longitude": e.longitude,
      "type": "Buyer",
      "title": "Buyer",
      "description": "Buyer Location",
    })
    setBuyer_coordinates(e.longitude + "," + e.latitude)

    setPushpinarr(arr);








  }
  async function getcoordinate() {
    await Geolocation.getCurrentPosition().then((position) => {

      setPushpinarr([{
        "latitude": position.coords.latitude,
        "longitude": position.coords.longitude,
        "title": "Buyer",
        "description": "Buyer",
      }])
    })
  }
  useEffect(() => {
    getcoordinate()
  }, [])
  const openCustomizer = (type) => {
    settabtripdate("")
    setabdelivery("")
    setActiveTab1(type)
    setRightSidebar(!rightSidebar)
    if (rightSidebar) {
      document.querySelector(".customizer-contain").classList.add('open');

    }
  }
  const closeCustomizer = () => {
    setRightSidebar(!rightSidebar)
    document.querySelector(".customizer-contain").classList.remove('open');

  }
  const LargeModaltoggle = () => {
    setLarge(!Large);
  }

  useEffect(() => {
    if (localStorage.getItem('usertype') !== "Buyer") {
      window.history.back();
    }
    settrip_type([{
      trip_name: "Upcoming Trip",
    }, {
      trip_name: "Completed Trip",
    }])




    getTripDetail()
  }, [])





  async function getTripDetail() {

    settabtripdate("")



    setabdelivery("")
    let { data: trip_Details, error } = await supabase
      .from('trip_details')
      .select('*')
      .eq("customer_id", localStorage.getItem("userid"))
      .order('id', { ascending: false })

    if (trip_Details !== null && trip_Details.length > 0) {

      let upcomingarr = []
      let completedarr = []
      for (let i = 0; i < trip_Details.length; i++) {
        if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
          upcomingarr.push(trip_Details[i])
        } else {
          completedarr.push(trip_Details[i])
        }
      }

      settrip_detail(upcomingarr)
      setcompleted_trip_detail(completedarr)
      setTimeout(() => {
        setclientHeight(window.innerHeight * 0.71)

      }, 1000)
    } else {
      if (error !== null) { }
      let { data: retrip_Details, reerror } = await supabase
        .from('trip_details')
        .select('*')
        .eq("customer_id", localStorage.getItem("userid"))
      if (retrip_Details !== null && retrip_Details.length > 0) {

        let upcomingarr = []
        let completedarr = []
        for (let i = 0; i < retrip_Details.length; i++) {
          if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
            upcomingarr.push(trip_Details[i])
          } else {
            completedarr.push(trip_Details[i])
          }
        }


        settrip_detail(upcomingarr)
        setcompleted_trip_detail(completedarr)
        setTimeout(() => {
          setclientHeight(window.innerHeight * 0.8)

        }, 1000)
      } else {
        if (reerror !== null) { }
        settrip_detail([])
        setcompleted_trip_detail([])
      }

    }
  }







  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  function convertdata(tripdate) {
    var date = new Date(tripdate)
    var day_date = date.getDate()
    var month = date.getMonth()
    var day = date.getDay()


    var newdate = dayNames[day] + "-" + day_date + "-" + monthNames[month]
    return newdate
  }
  async function Updatecoordinate() {
    if (Buyer_coordinates === "") {
      toast.error("Please select Buyer Location");
    } else {
      let { data: updateTrip, error } = await supabase
        .from('trip_details')
        .update({ Buyer_coordinate: Buyer_coordinates })
        .eq("trip_id", trip_id)
      if (updateTrip !== null) {
        toast.success("Buyer Location Updated Successfully");
        getTripDetail()
        setLarge(!Large);
        setPushpinarr([{
          "latitude": 28.750591076255212,
          "longitude": 77.20027622752754,
          "title": "Buyer",
          "description": "Buyer",
        }])

      } else {
        if (error !== null) { }
        toast.error("Something went wrong");
      }
    }

  }

  async function gettripfilterdata(data, type) {

    if (type === "date") {




      setabdelivery("")

      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("trip_date", data)
        .eq("customer_id", localStorage.getItem("userid"))
        .order('id', { ascending: false })


      if (trip_Details !== null && trip_Details.length > 0) {

        let upcomingarr = []
        let completedarr = []
        for (let i = 0; i < trip_Details.length; i++) {
          if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
            upcomingarr.push(trip_Details[i])
          } else {
            completedarr.push(trip_Details[i])
          }
        }

        settrip_detail(upcomingarr)
        setcompleted_trip_detail(completedarr)
      } else {
        if (error !== null) { }
        let { data: retrip_Details, reerror } = await supabase
          .from('trip_details')
          .select('*')
          .eq("trip_date", data)
          .eq("customer_id", localStorage.getItem("userid"))
          .order('id', { ascending: false })
        console.log(retrip_Details)
        if (retrip_Details !== null && retrip_Details.length > 0) {

          let upcomingarr = []
          let completedarr = []
          for (let i = 0; i < retrip_Details.length; i++) {
            if (new Date().getTime() <= new Date(retrip_Details[i].trip_date).getTime()) {
              upcomingarr.push(retrip_Details[i])
            } else {
              completedarr.push(retrip_Details[i])
            }
          }


          settrip_detail(upcomingarr)
          setcompleted_trip_detail(completedarr)
        } else {
          // toast.error("No Trip Details Found")
          if (reerror !== null) { }
          settrip_detail([])
          setcompleted_trip_detail([])
        }

      }
    } else if (type === "delivery") {

      settabtripdate("")




      let { data: trip_Details, error } = await supabase
        .from('trip_details')
        .select('*')
        .eq("delivery_status", data)
        .eq("customer_id", window.localStorage.getItem("userid"))
        .order('id', { ascending: false })

      if (trip_Details !== null && trip_Details.length > 0) {

        let upcomingarr = []
        let completedarr = []
        for (let i = 0; i < trip_Details.length; i++) {
          if (new Date().getTime() <= new Date(trip_Details[i].trip_date).getTime()) {
            upcomingarr.push(trip_Details[i])
          } else {
            completedarr.push(trip_Details[i])
          }
        }

        settrip_detail(upcomingarr)
        setcompleted_trip_detail(completedarr)

      } else {
        if (error !== null) { }
        let { data: re_trip_Details, re_error } = await supabase
          .from('trip_details')
          .select('*')
          .eq("delivery_status", data)
          .eq("customer_id", window.localStorage.getItem("userid"))
          .order('id', { ascending: false })
        if (re_trip_Details !== null && re_trip_Details.length > 0) {

          let upcomingarr = []
          let completedarr = []
          for (let i = 0; i < re_trip_Details.length; i++) {
            for (let i = 0; i < re_trip_Details.length; i++) {
              if (new Date().getTime() <= new Date(re_trip_Details[i].trip_date).getTime()) {
                upcomingarr.push(re_trip_Details[i])
              } else {
                completedarr.push(re_trip_Details[i])
              }
            }
          }


          settrip_detail(upcomingarr)
          setcompleted_trip_detail(completedarr)
        } else {
          if (re_error !== null) { }
          // toast.error("No Buyer Details Found")
          settrip_detail([])
          setcompleted_trip_detail([])
        }
      }
    }



  }
  async function updateInvoice(id) {
    window.localStorage.setItem("invoice", id)
    window.location.href = "/Invoice/"+ id+`/${window.localStorage.getItem("usertype")}`

  }

  const handlePdf = () => {
    const downloadSection = document.getElementById('trip_table');




    html2canvas(downloadSection).then(function (
      canvas
    ) {
      var cWidth = canvas.width;
      var cHeight = canvas.height;
      var topLeftMargin = 0;
      var pdfWidth = cWidth + topLeftMargin * 2;
      var pdfHeight = pdfWidth * 1.5 + topLeftMargin * 2;
      var canvasImageWidth = cWidth;
      var canvasImageHeight = cHeight;
      var totalPDFPages = Math.ceil(cHeight / pdfHeight) - 1;
      canvas.getContext('2d');
      var imgData = canvas.toDataURL('image/png', 1.0);
      var pdf = new jsPDF('p', 'pt', [pdfWidth, pdfHeight]);
      pdf.addImage(
        imgData,
        'PNG',
        topLeftMargin,
        topLeftMargin,
        canvasImageWidth,
        canvasImageHeight
      );
      for (var i = 1; i <= totalPDFPages; i++) {
        pdf.addPage(pdfWidth, pdfHeight);
        pdf.addImage(
          imgData,
          'PNG',
          topLeftMargin,
          -(pdfHeight * i) + topLeftMargin * 0,
          canvasImageWidth,
          canvasImageHeight
        );
      }
      pdf.save('TripDriver_details.pdf');
    });
  }



  return (
    <Fragment>
      <Breadcrumb parent="Dashboard" title="Trip Details" />
      <Container fluid={true}>
        <Row>
          <Col sm="12" id="maintrip" style={window.innerWidth < 800 ? { paddingLeft: '5px', paddingRight: "5px" } : { width: "100%" }}>
            <Modal isOpen={Large} toggle={LargeModaltoggle} size="lg" centered>
              <ModalHeader toggle={LargeModaltoggle}>
                Add Location
              </ModalHeader>
              <ModalBody>
                <div className='map-four' >
                  <ReactBingmaps

                    center={[24.676361555849134, 77.49976170393126]}
                    zoom={5}
                    id="Addbuyerlocation"
                    className="customClass"
                    bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}
                    getLocation={
                      { addHandler: "click", callback: AddPushPinOnClick }
                    }
                    infoboxesWithPushPins={
                      pushpinarr.length > 0 && pushpinarr.map((item) => {
                        return (
                          {


                            location: [item.latitude, item.longitude],

                            addHandler: "mouseover", //on mouseover the pushpin, infobox shown
                            infoboxOption: { title: item.title, description: item.description },
                            pushPinOption: { title: item.title, description: item.description },

                          }
                        );
                      })


                    }


                  />
                </div>
                <br />
                <button className="btn btn-primary" style={{ float: "right" }} onClick={() => { Updatecoordinate() }}>Update</button>
              </ModalBody>
            </Modal>
            <div className="customizer-contain">
              <div className="tab-content" id="c-pills-tabContent">
                <div className="customizer-header">
                  <i className="icon-close" onClick={closeCustomizer}></i>
                  <h5>{t("filter")}</h5>



                </div>
                <div className="customizer-body custom-scrollbar">
                  <TabContent activeTab={activeTab1}>
                    <TabPane tabId="1">
                      <Row>
                        <Col sm="12" style={{ display: "flex", justifyContent: "end", margin: "10px" }}>
                          <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer", backgroundColor: "#e8e8e8", padding: "5px 10px", borderRadius: "20px" }} onClick={() => {
                            getTripDetail();
                          }}>{t("Clear")}</div>

                        </Col>
                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="exampledate">{t("Trip Date")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                          </div>
                        </Col>




                        <Col sm="12" style={{ display: "flex", justifyContent: "start", margin: "10px", flexDirection: "column" }}>
                          <Label for="examplestatus">{t("Delivery Status")}</Label>

                          <div style={{ textAlign: "center" }}>
                            <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                              <option value={""}>{t("Delivery")} </option>
                              <option value={"Delivered"}>{t("Delivered")}</option>
                              <option value={"IN-TRANSIT"}>{t("IN-TRANSIT")}</option>

                            </Input></div>
                        </Col>

                        <Col sm="12" style={{ display: "flex", justifyContent: "center", margin: "10px" }}>

                          <div style={{ textAlign: "center" }}>
                            <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "5px" }} onClick={() => { closeCustomizer(); trip_detail.length > 0 ? settrip_status(0) : settrip_status(1) }}>{t("Show Result")} {tabdelivery !== "" || tabtripdate !== "" ? parseInt(trip_detail.length) + parseInt(completed_trip_detail.length) : ""}</button>
                          </div>


                        </Col>
                      </Row>
                    </TabPane>
                  </TabContent>
                </div>
              </div>
            </div>
            {window.innerWidth < 800 ? <>
              <Table className='table-borderless'>
                <tbody>
                  <tr style={{ display: "flex", alignItems: "center" }}>
                    {trip_type.length > 0 && trip_type.map((item, index) => {
                      return (
                        <td style={{ verticalAlign: "inherit" }} key={index}>
                          <button className="btn " style={{ backgroundColor: index === trip_status ? "#211833" : "#e8e8e8", color: index !== trip_status ? "black" : "white", borderRadius: "20px", fontSize: "14px", padding: "9px 12px" }} onClick={() => { getTripDetail(); settrip_status(index) }}>{item.trip_name}</button>
                        </td>
                      )
                    })}
                    <td>
                      <div onClick={() => { openCustomizer('1') }} style={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
                        <Icon icon="bx:filter" color="black" width="35" height="35" />
                      </div>
                    </td>


                  </tr>
                </tbody>
              </Table>
              <div style={clientHeight !== "" ? { height: clientHeight + "px", overflowY: "scroll", padding: "5px" } : { height: "100%" }}>
                <Accordion>

                  <div className="default-according" id="accordionclose">
                    {trip_status === 0 ? <>
                      {trip_detail.length > 0 ? <>
                        {trip_detail.map((data, i) => {
                          return (
                            <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                              <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                                <h5 className="mb-0" style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                    <div className="email-app-sidebar left-bookmark">
                                      <div className="media" style={{ alignItems: "center " }}>
                                        <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px 15px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div>
                                        </div>
                                        <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Trip To</span>
                                          <span style={{ display: "block" }}>{data.customer_name}</span>
                                          <span style={{ display: "block" }}>{data.customer_address}</span>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>From</span>
                                          <span style={{ display: "block" }}>{data.man_name}</span>
                                          <span style={{ display: "block" }}>{data.man_address}</span>
                                        </div>


                                      </div>
                                    </div>



                                  </Accordion.Toggle>
                                  <div className="media-size-email" style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}><div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#ba78e3", padding: "10px", cursor: "pointer" }} onClick={() => {
                                    updateInvoice(data.trip_id)
                                  }}><Icon icon="carbon:view-filled" color="#a927f9" width="20" height="20" /></div>
                                    &nbsp;

                                  </div>
                                </h5>
                              </CardHeader>
                              <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                                <CardBody>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>

                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle</span>
                                        <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                        <span style={{ display: "block" }}>{data.inventory_type}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                        <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                        <span style={{ display: "block" }}>{data.payment_status}</span>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Driver</span>
                                        <span style={{ display: "block" }}>{data.driver_name}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                        <span style={{ display: "block" }}>{data.inventory_quantity}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Charges</span>
                                        <span style={{ display: "block" }}>&#8377; &nbsp;{data.transport_charges}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Delivered</span>

                                        <span style={{ display: "block" }}>{data.delivery_status}</span>
                                      </div>


                                    </div>
                                    <br />
                                    <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {parseInt(data.trip_amount) + ((parseInt(data.trip_amount) * 18) / 100) + parseInt(data.transport_charges) + ((parseInt(data.transport_charges) * 5) / 100)}</span></p>
                                    {data.Buyer_coordinate === null || data.Buyer_coordinate === "" ? <button className="btn " style={{ backgroundColor: "#E50014", color: "white", borderRadius: "20px" }} onClick={() => {
                                      LargeModaltoggle(); settrip_id(data.trip_id); getcoordinate()
                                    }}>Add Location</button> : ""}
                                    {data.driver_coordinates !== null && data.driver_coordinates !== "" && data.Buyer_coordinate === null || data.Buyer_coordinate === "" ?

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div> : ""}
                                    {data.Buyer_coordinate !== null && data.Buyer_coordinate !== "" && data.driver_coordinates !== null && data.driver_coordinates !== "" ?

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            {
                                              location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                              option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            }
                                          ]
                                          }















                                        />
                                      </div> :

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps

                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            // {
                                            //     location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            //     option: { title: data.driver_name, subTitle: "Driver" },


                                            // },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div>
                                    }
                                  </div>


                                </CardBody>
                              </Accordion.Collapse>
                            </Card>
                          )


                        })}</> : <Card>
                        <CardHeader >
                          <h5 className="mb-0">
                            <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                              No Record Found
                            </Accordion.Toggle>
                          </h5>
                        </CardHeader>
                      </Card>}</> : <>{completed_trip_detail.length > 0 ? <>
                        {completed_trip_detail.map((data, i) => {
                          return (
                            <Card key={i} style={{ boxShadow: "rgba(0, 0, 0, 0.35) 0px 5px 15px", borderRadius: "10px" }}>
                              <CardHeader onClick={() => { document.getElementById(`one${i + 1}`).click() }} style={{ cursor: "pointer", borderRadius: "10px" }}>
                                <h5 className="mb-0" style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center"
                                }}>
                                  <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" eventKey={i + 1} id={"one" + (i + 1)} style={{ padding: "0px" }}>
                                    <div className="email-app-sidebar left-bookmark">
                                      <div className="media" style={{ alignItems: "center " }}>
                                        <div className="media-size-email"> <div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px 15px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div>
                                        </div>
                                        <div className="media-body" style={{ textAlign: "left", marginLeft: "20px" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Trip To</span>
                                          <span style={{ display: "block" }}>{data.customer_name}</span>
                                          <span style={{ display: "block" }}>{data.customer_address}</span>
                                          <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>From</span>
                                          <span style={{ display: "block" }}>{data.man_name}</span>
                                          <span style={{ display: "block" }}>{data.man_address}</span>
                                        </div>


                                      </div>
                                    </div>



                                  </Accordion.Toggle>
                                  <div className="media-size-email" style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    flexDirection: "column",
                                  }}> <div style={{ borderRadius: "10px", lineHeight: "15px", textAlign: "center", backgroundColor: "#ba78e3", padding: "10px", cursor: "pointer" }} onClick={() => {
                                    updateInvoice(data.trip_id)
                                  }}><Icon icon="carbon:view-filled" color="#a927f9" width="20" height="20" /></div>
                                    &nbsp;

                                  </div>
                                </h5>
                              </CardHeader>
                              <Accordion.Collapse eventKey={i + 1} style={{ borderRadius: "10px" }}>
                                <CardBody>
                                  <div className="email-app-sidebar left-bookmark">
                                    <div className="media" style={{ alignItems: "center " }}>

                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Vehicle</span>
                                        <span style={{ display: "block" }}>{data.vehicle_number}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Stock</span>
                                        <span style={{ display: "block" }}>{data.inventory_type}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Distance</span>
                                        <span style={{ display: "block" }}>{data.transport_distance} Km</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Payment Status</span>
                                        <span style={{ display: "block" }}>{data.payment_status}</span>
                                      </div>
                                      <div className="media-body" style={{ textAlign: "left" }}>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Driver</span>
                                        <span style={{ display: "block" }}>{data.driver_name}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Quantity</span>
                                        <span style={{ display: "block" }}>{data.inventory_quantity}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Charges</span>
                                        <span style={{ display: "block" }}>&#8377; &nbsp;{data.transport_charges}</span>
                                        <span style={{ display: "block", fontWeight: "500", color: "#E50014" }}>Delivered</span>

                                        <span style={{ display: "block" }}>{data.delivery_status}</span>
                                      </div>


                                    </div>
                                    <br />
                                    <p style={{ fontSize: "15px", fontWeight: "500" }}>Amount  &nbsp; <span style={{ fontWeight: "500", color: "#E50014" }}>&#8377; {parseInt(data.trip_amount) + ((parseInt(data.trip_amount) * 18) / 100) + parseInt(data.transport_charges) + ((parseInt(data.transport_charges) * 5) / 100)}</span></p>
                                    {data.Buyer_coordinate === null || data.Buyer_coordinate === "" ? <button className="btn " style={{ backgroundColor: "#E50014", color: "white", borderRadius: "20px" }} onClick={() => {
                                      LargeModaltoggle(); settrip_id(data.trip_id); getcoordinate()
                                    }}>Add Location</button> : ""}
                                    {data.driver_coordinates !== null && data.driver_coordinates !== "" && data.Buyer_coordinate === null || data.Buyer_coordinate === "" ?

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div> : ""}
                                    {data.Buyer_coordinate !== null && data.Buyer_coordinate !== "" && data.driver_coordinates !== null && data.driver_coordinates !== "" ?

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps
                                          id={data.trip_id}
                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            {
                                              location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                              option: { title: data.driver_name, subTitle: "Driver" },


                                            },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            {
                                              location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                              option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            }
                                          ]
                                          }















                                        />
                                      </div> :

                                      <div className='map-seven' key={i} >
                                        <ReactBingmaps

                                          center={[parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])]}
                                          zoom={12}
                                          className="customClass"
                                          bingmapKey={"AksOASfzdybmndjlOxhWnhZaNtzG5CMgqUFIgB5Ji8W6Gr748WQL5mijk5w4OmDD"}


                                          pushPins={[





                                            // {
                                            //     location: [parseFloat(data.driver_coordinates.split(",")[1]), parseFloat(data.driver_coordinates.split(",")[0])],
                                            //     option: { title: data.driver_name, subTitle: "Driver" },


                                            // },
                                            {
                                              location: [parseFloat(data.supplier_coordinate.split(",")[1]), parseFloat(data.supplier_coordinate.split(",")[0])],
                                              option: { title: data.man_name, subTitle: "Supplier", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            },
                                            // {
                                            //     location: [parseFloat(data.Buyer_coordinate.split(",")[1]), parseFloat(data.Buyer_coordinate.split(",")[0])],
                                            //     option: { title: data.customer_name, subTitle: "Buyer", icon: "https://www.bingmapsportal.com/Content/images/poi_custom.png", anchor: [12, 39], height: 30, width: 30 },


                                            // }
                                          ]
                                          }















                                        />
                                      </div>
                                    }
                                  </div>


                                </CardBody>
                              </Accordion.Collapse>
                            </Card>
                          )


                        })}</> : <Card>
                        <CardHeader >
                          <h5 className="mb-0">
                            <Accordion.Toggle as={Card.Header} className="btn btn-link" color="default" >
                              No Record Found
                            </Accordion.Toggle>
                          </h5>
                        </CardHeader>
                      </Card>}</>}
                  </div>

                </Accordion>
              </div>
            </> :

              <Card>





                <CardBody>
                  <div className="table-responsive ">
                    <Table className='table-borderless'>
                      <tbody>
                        <tr style={{ display: "flex", alignItems: "center" }}>
                          <td style={{ verticalAlign: "inherit" }}>
                            <div style={{ textAlign: "end", fontWeight: "500", cursor: "pointer" }} onClick={() => {
                              getTripDetail()
                            }}>All</div>
                          </td>
                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input type="date" value={tabtripdate} onChange={(e) => { gettripfilterdata(e.target.value, "date"); settabtripdate(e.target.value) }} />
                            </div>
                          </td>




                          <td>
                            <div style={{ textAlign: "center" }}>
                              <Input className="form-control" type="select" placeholder="Enter Delivered At" value={tabdelivery} onChange={(e) => { gettripfilterdata(e.target.value, "delivery"); setabdelivery(e.target.value) }} >
                                <option value={""}>Delivery </option>
                                <option value={"Delivered"}>Delivered</option>
                                <option value={"IN-TRANSIT"}>IN-TRANSIT</option>

                              </Input></div>
                          </td>

                          <td>
                            <div style={{ textAlign: "center" }}>
                              <button className="btn " style={{ backgroundColor: "black", color: "white", borderRadius: "7px" }} onClick={() => { handlePdf() }}>Download PDF</button>
                            </div>
                          </td>



                        </tr>
                      </tbody>
                    </Table>

                    <Table className='table-borderless'>
                      <tbody>
                        <tr style={{ display: "flex", alignItems: "center" }}>
                          {trip_type.length > 0 && trip_type.map((item, index) => {
                            return (
                              <td style={{ verticalAlign: "inherit" }} key={index}>
                                <button className="btn " style={{ backgroundColor: index === trip_status ? "#24a0ed" : "whitesmoke", color: index !== trip_status ? "black" : "white", borderRadius: "7px" }} onClick={() => { getTripDetail(); settrip_status(index) }}>{item.trip_name}</button>
                              </td>
                            )
                          })}


                        </tr>
                      </tbody>
                    </Table>

                    <Table id='trip_table' >
                      <thead>
                        <tr style={{ textAlign: "center" }}>
                          <th scope="col">{"Date"}</th>
                          <th scope="col">{"Vehicle"}</th>
                          <th scope="col">{"Driver"}</th>
                          <th scope="col">{"Quantity"}</th>
                          <th scope="col">{"Inventory"}</th>

                          <th scope="col">{"Buyer"}</th>

                          <th scope='col'>{"Trip Distance"}</th>
                          <th scope="col">{"Trip Amount"}</th>
                          <th scope="col">{"Transport Cost"}</th>
                          <th scope="col">{"Delivery"}</th>
                          <th scope="col">{"Payment"}</th>

                          <th scope="col">{"Action"}</th>
                        </tr>
                      </thead>
                      <tbody>
                        {trip_status === 0 ? <>
                          {trip_detail.length > 0 ? <>
                            {trip_detail.map((data, i) => {
                              return (
                                <tr key={i} style={{ textAlign: "center" }}>
                                  <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div></td>
                                  <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "500" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                                  <td>{data.driver_name}</td>
                                  <td>{data.inventory_quantity}</td>
                                  <td>{data.inventory_type}</td>
                                  <td>{<span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span>}</td>
                                  <td>{data.transport_distance} Km</td>
                                  <td>{data.trip_amount}</td>
                                  <td>{data.transport_charges}</td>


                                  <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td>
                                  <td>{data.payment_status === "Paid" ? <span style={{ textTransform: "uppercase", backgroundColor: "darkgreen", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "orange", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span>}</td>


                                  <td>    {data.Buyer_coordinates === null || data.Buyer_coordinates === "" ? <button className="btn btn-primary m-1" onClick={() => {
                                    LargeModaltoggle(); settrip_id(data.trip_id); getcoordinate()
                                  }}>Add Location</button> : ""}<button className='btn btn-info m-1' onClick={() => {
                                    updateInvoice(data.trip_id)

                                  }}><i className='fa fa-eye '></i> View</button></td>
                                </tr>
                              )
                            })}
                          </>
                            : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}
                        </> : <>
                          {completed_trip_detail.length > 0 ? <>
                            {completed_trip_detail.map((data, i) => {
                              return (
                                <tr key={i} style={{ textAlign: "center" }}>
                                  <td><div style={{ borderRadius: "5px", lineHeight: "15px", textAlign: "center", backgroundColor: "lightblue", padding: "5px" }}><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[0]}</div><div style={{ fontSize: "18px", fontWeight: "700" }}>{convertdata(data.trip_date).split("-")[1]}</div><div style={{ fontSize: "10px" }}>{convertdata(data.trip_date).split("-")[2]}</div></div></td>
                                  <td><div style={{ backgroundColor: "#ffdd00", fontWeight: "500", padding: "5px", borderRadius: "5px", textAlign: "center" }}><div style={{ fontWeight: "400" }}>{data.vehicle_number.substring(0, 6)}</div><div style={{ fontWeight: "500" }}>{data.vehicle_number.substring(6, 10)}</div></div></td>
                                  <td>{data.driver_name}</td>
                                  <td>{data.inventory_quantity}</td>
                                  <td>{data.inventory_type}</td>
                                  <td>{<span style={{ color: "darkgreen", textTransform: "uppercase", fontWeight: "500" }}>{data.customer_name}</span>}</td>
                                  <td>{data.transport_distance} Km</td>
                                  <td>{data.trip_amount}</td>
                                  <td>{data.transport_charges}</td>


                                  <td>{data.delivery_status === "IN-TRANSIT" ? <span style={{ textTransform: "uppercase", backgroundColor: "skyblue", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "purple", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.delivery_status}</span>}</td>
                                  <td>{data.payment_status === "Paid" ? <span style={{ textTransform: "uppercase", backgroundColor: "darkgreen", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span> : <span style={{ textTransform: "uppercase", backgroundColor: "orange", padding: "5px 15px", color: "white", borderRadius: "30px" }}>{data.payment_status}</span>}</td>


                                  <td>   {data.Buyer_coordinate === null || data.Buyer_coordinate === "" ? <button className="btn btn-primary m-1" onClick={() => {
                                    LargeModaltoggle(); settrip_id(data.trip_id); getcoordinate()
                                  }}>Add Location</button> : ""}<button className='btn btn-info m-1' onClick={() => {
                                    updateInvoice(data.trip_id)

                                  }}><i className='fa fa-eye '></i> View</button></td>
                                </tr>
                              )
                            })}
                          </>
                            : <tr style={{ textAlign: "center" }}><td colSpan="12" style={{ textAlign: "center" }}>No Record Found</td></tr>}
                        </>}

                      </tbody>
                    </Table>
                  </div>
                </CardBody>
              </Card>}
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default Trip;